document.addEventListener('DOMContentLoaded', () => {
  // Mobile menu toggle
  const openMenuButton = document.getElementById('open-menu')
  const body = document.body

  if (openMenuButton) {
    openMenuButton.addEventListener('click', () => {
      body.classList.toggle('menu-open')
    })
  }

  // Fechar menu ao clicar fora dele
  document.addEventListener('click', (e) => {
    const target = e.target as HTMLElement
    if (body.classList.contains('menu-open') && 
        !target.closest('#mobile-menu-canvas') && 
        !target.closest('#open-menu')) {
      body.classList.remove('menu-open')
    }
  })

  // Funções para gerenciar o menu desktop
  const handleDesktopMenu = () => {
    // Verificar se está em desktop
    if (window.innerWidth < 640) return
    
    // Selecionar todos os itens com submenu no menu principal
    const menuItemsWithChildren = document.querySelectorAll('#menu-main > .menu-item-has-children')
    
    // Adicionar eventos hover em cada item
    menuItemsWithChildren.forEach(menuItem => {
      // Mostrar submenu ao entrar com mouse
      menuItem.addEventListener('mouseenter', () => {
        const submenu = menuItem.querySelector('.sub-menu')
        if (submenu) submenu.classList.add('submenu-active')
      })
      
      // Esconder submenu ao sair com mouse
      menuItem.addEventListener('mouseleave', () => {
        const submenu = menuItem.querySelector('.sub-menu')
        if (submenu) submenu.classList.remove('submenu-active')
      })
    })
  }

  // Inicializar menu desktop
  handleDesktopMenu()
  
  // Atualizar configuração ao redimensionar
  window.addEventListener('resize', handleDesktopMenu)

  // Submenu toggle para mobile - modificado para funcionar corretamente
  const setupMobileSubmenus = () => {
    // Selecionar todos os itens com submenu no menu mobile
    const mobileMenuItemsWithChildren = document.querySelectorAll('#mobile-menu-canvas .menu-item-has-children')
    
    mobileMenuItemsWithChildren.forEach(item => {
      const link = item.querySelector('a')
      
      if (link) {
        // Remover eventos anteriores para evitar duplicação
        link.removeEventListener('click', handleMobileSubmenuToggle)
        // Adicionar novo evento
        link.addEventListener('click', handleMobileSubmenuToggle)
      }
    })
  }
  
  // Função para lidar com o toggle do submenu mobile
  function handleMobileSubmenuToggle(e) {
    e.preventDefault()
    const parentItem = this.parentElement
    const submenu = parentItem.querySelector('.sub-menu')
    
    if (submenu) {
      // Verificar estado atual
      const isOpen = parentItem.getAttribute('data-state') === 'open'
      
      // Alternar o estado
      if (isOpen) {
        parentItem.removeAttribute('data-state')
        submenu.removeAttribute('data-state')
        this.removeAttribute('data-state')
      } else {
        parentItem.setAttribute('data-state', 'open')
        submenu.setAttribute('data-state', 'open')
        this.setAttribute('data-state', 'open')
      }
    }
  }
  
  // Configurar submenus mobile
  setupMobileSubmenus()
  
  // Reconfigurar quando a janela for redimensionada
  window.addEventListener('resize', setupMobileSubmenus)
})
